var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', [_c('legend', [_vm._v("Add Shipment EscalatedQC\n      ")]), _vm._v(" "), _c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipping ID :")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.upshippingID),
      expression: "upshippingID"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('upshippingID')
    },
    attrs: {
      "id": "upshippingID",
      "type": "text",
      "name": "upshippingID",
      "placeholder": "Enter Shipping ID"
    },
    domProps: {
      "value": (_vm.upshippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.upshippingID = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.upshippingID')),
      expression: "errors.has('form-1.upshippingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please enter Shipping ID.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Comment :")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-comment'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('comment')
    },
    attrs: {
      "name": "comment",
      "rows": "2",
      "cols": "50",
      "id": "comment",
      "placeholder": "Please enter comment"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  }), _vm._v("  \n               ")])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.comment')),
      expression: "errors.has('form-1.comment')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please enter comment.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoad == true
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Save")]), _vm._v("  \n                "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoad == true
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Reset")])])], 1)])]), _vm._v(" "), _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoad,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoad = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('legend', [_vm._v(" Search Shipment"), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.plus),
      expression: "plus"
    }],
    staticClass: "fa fa-filter",
    staticStyle: {
      "float": "right",
      "font-size": "28px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.showsearch
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.minus),
      expression: "minus"
    }],
    staticClass: "fa fa-filter",
    staticStyle: {
      "float": "right",
      "font-size": "28px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.showsearch
    }
  })]), _vm._v(" "), _c('b-card', [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearchForm),
      expression: "showSearchForm"
    }],
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-2')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("From Date:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    ref: "fromDate",
    attrs: {
      "lang": "en",
      "name": "fromDate",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("To Date : ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    ref: "toDate",
    attrs: {
      "lang": "en",
      "name": "toDate",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Shipping ID :")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "shippingID",
      "type": "text",
      "name": "shippingID",
      "placeholder": "Enter Shipping ID"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }
    }
  }), _vm._v("  \n                 ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading == true
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" \n                "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading == true
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("Reset")])], 1)], 1)])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "text": "Loading Shipments"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("SR. No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.fetcheddata), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s((index) + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.HubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateformat")(data.createddate)))])])
  }), _vm._v(" "), ((_vm.fetcheddata && _vm.fetcheddata.length == 0) || _vm.fetcheddata.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No Data found")])]) : _vm._e()], 2)], 1), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58158892","hasScoped":true}!./src/views/components/ReversePassQC/ReversePassQC.component.html
// module id = 1323
// module chunks = 1